module.exports = __webpack_public_path__ + "img/Druid.08d312e2.png";